import {IYandexMapContext, YandexMapContext} from 'modules/yandex-map/context';

export const YandexMapProvider: FC<IYandexMapContext> = ({service, ready, children}) => {
    return <YandexMapContext.Provider value={{ready, service}}>{children}</YandexMapContext.Provider>;
};
